module.exports = __webpack_public_path__ + "static/img/til31.200c1e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/til31.png
// module id = XI01
// module chunks = 1